import createMaintenanceService from "services/maintenance/createMaintenanceService";

const employeePositionService = createMaintenanceService(
    "/preferences/EmployeePosition"
);

export default employeePositionService;
